import * as React from "react";
import {AccountPageWrapper} from "components/account/widgets/AccountPageWrapper";
import {UIState} from "data/UIState";
import {AccountContentContainer} from "components/account/widgets/AccountContentContainer";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {IAccountPage, AccountPages} from "components/account/Account";

interface Props {
  onChangeAccountPage:(page:IAccountPage) => void;
}

export function AccountDeleteConfirm(props: Props) {

  function cancel() {
    props.onChangeAccountPage(AccountPages.DataPrivacy);
  }

  return (
    <AccountPageWrapper
      title={"Delete Account"}
      backOrCloseAction={cancel}
      backOrCloseLabel={"Back to Data & Privacy"}
    >
      <AccountContentContainer>

        <ConfirmDeleteAccount onCancel={cancel}/>

      </AccountContentContainer>
    </AccountPageWrapper>
  );

}


@observer
class ConfirmDeleteAccount extends React.Component<{onCancel:()=>void}> {
  @observable email:string;
  @observable password:string;
  @observable deleting:boolean = false;
  @observable error:boolean = false;

  handleCancel = () => {
    this.email = '';
    this.password = '';
    this.deleting = false;
    this.props.onCancel();
  }

  attemptDeletion = () => {
    if(!this.email || !this.password) {
      alert('Your Email and Password are required to delete your account.');
    } else {
      this.deleting = true;
      UIState.deleteAccount(this.email, this.password)
        .then(()=>{
          document.location.href = '/';
        })
        .catch(()=>{
          alert('Failed to delete account. Please try again. If this problem persists, contact support@well-concepts.com for assistance.')
          this.error = true;
          this.deleting = false;
        })
    }
  }

  render() {
    return(
      <>

        <h2 className={'level2'}>Confirm account deletion?</h2>
        <div>
          <p>Deleting your account is permanent. There will be no way to recover your data, it will be completely
          purged from our system. Please confirm by entering your correct email and password.
        </p>
        {this.error &&
          <p className="error">There was a problem trying to delete your account. Please try again. If the problem persists, please
            contact Wellness Concepts support for help using <a href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>.</p>
        }
        </div>

          <fieldset>
            <label htmlFor={"EmailADC"}>Email</label>
            <input id="EmailADC" style={{maxWidth:"390px"}} disabled={this.deleting} value={this.email} onChange={(e)=>{ this.email = e.target.value; }} placeholder="email" type="text"/><br/>
          </fieldset>

          <fieldset>
            <label htmlFor={"PasswordADC"}>Password</label>
            <input id="PasswordADC" style={{maxWidth:"390px"}} disabled={this.deleting} value={this.password} onChange={(e)=>{ this.password = e.target.value; }} placeholder="password" type="password"/><br/>
          </fieldset>


        <div className="action-buttons">
          <div className={"spacer"}></div>
          <button className={"secondary"} onClick={this.handleCancel}>Cancel</button>
          <button disabled={this.deleting} className={"primary"} onClick={this.attemptDeletion}>Delete My Account</button>
        </div>


      </>
    );
  }
}

